var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex",class:{
        'flex-column' : !_vm.isHorizontal, 
        'mt2' : _vm.isHorizontal
    },staticStyle:{"flex":"1"}},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,class:{
            'w-25' : _vm.isHorizontal,
            'pr2' : index !== _vm.images.length - 1 && _vm.isHorizontal,
            'pb2' : index !== _vm.images.length - 1 && !_vm.isHorizontal }},[_c('img',{staticClass:"grow pointer  w-100 h-100",attrs:{"src":image.path},on:{"click":function($event){_vm.$emit('select', index)}}})])}))}
var staticRenderFns = []

export { render, staticRenderFns }